/**
 * Returns if the current url is equal to result page.
 */
const isSettingPage = (location: any = window.location) => {
  return location.pathname.includes('/myaccount/settings');
};

export default isSettingPage;
